import { createAsyncThunk } from "@reduxjs/toolkit";
import { GetVerificationCode } from "../../domain/usecases/getVerificationCode";
import {
	SendVerificationPhotoConfig,
	SendVerificationPhotoParams,
} from "../../domain/usecases/sendVerificationPhoto";
import { CreateVerificationLivenessSession } from "../../domain/usecases/createVerificationLivenessSession";
import {
	SaveVerificationLivenessResult,
	SaveVerificationLivenessResultParams,
} from "../../domain/usecases/saveVerificationLivenessResult";
import { CreateAdminLiveFaceSession } from "../../domain/usecases/createAdminLiveFaceSession";
import {
	SaveAdminLiveFaceResult,
	SaveAdminLiveFaceResultParams,
} from "../../domain/usecases/saveAdminLiveFaceResult";
import { setUpdateGetProfileConfig } from "../../../profile/presentation/store/OnboardingSlice";
import { GetPlaces, GetPlacesParams } from "../../domain/usecases/getPlaces";
import {
	GetDetailsPlace,
	GetDetailsPlaceParams,
} from "../../domain/usecases/getDetailsPlace";

export const onGetVerificationCode = createAsyncThunk(
	"profile/verification-code",
	async (_, { extra }) => {
		const { getVerificationCode } = extra as {
			getVerificationCode: GetVerificationCode;
		};
		const result = await getVerificationCode.execute();
		return result;
	}
);

export const onSendVerificationPhoto = createAsyncThunk(
	"profile/verification-photo",
	async (params: SendVerificationPhotoParams, { extra, dispatch }) => {
		const { sendVerificationPhoto } = extra as {
			sendVerificationPhoto: SendVerificationPhotoConfig;
		};
		const result = await sendVerificationPhoto.execute(params);
		if (!result.requiresLiveness && result.verificationPhotoStatus) {
			dispatch(setUpdateGetProfileConfig(result.verificationPhotoStatus));
		}
		return result;
	}
);

export const onSaveVerificationLivenessResult = createAsyncThunk(
	"profile/verification-liveness/result",
	async (params: SaveVerificationLivenessResultParams, { extra, dispatch }) => {
		const { saveVerificationLivenessResult } = extra as {
			saveVerificationLivenessResult: SaveVerificationLivenessResult;
		};
		const result = await saveVerificationLivenessResult.execute(params);
		if (result === "passed") {
			dispatch(setUpdateGetProfileConfig("pending"));
		}
		return result;
	}
);

export const onCreateVerificationLivenessSession = createAsyncThunk(
	"profile/verification-liveness/session",
	async (_, { extra }) => {
		const { createVerificationLivenessSession } = extra as {
			createVerificationLivenessSession: CreateVerificationLivenessSession;
		};
		return createVerificationLivenessSession.execute();
	}
);

export const onCreateAdminLiveFaceSession = createAsyncThunk(
	"profile/admin-live-face/session",
	async (_, { extra }) => {
		const { createAdminLiveFaceSession } = extra as {
			createAdminLiveFaceSession: CreateAdminLiveFaceSession;
		};
		return createAdminLiveFaceSession.execute();
	}
);

export const onSaveAdminLiveFaceResult = createAsyncThunk(
	"profile/admin-live-face/result",
	async (params: SaveAdminLiveFaceResultParams, { extra }) => {
		const { saveAdminLiveFaceResult } = extra as {
			saveAdminLiveFaceResult: SaveAdminLiveFaceResult;
		};
		return saveAdminLiveFaceResult.execute(params);
	}
);

export const onGetPlaces = createAsyncThunk(
	"location/search",
	async (params: GetPlacesParams, { extra }) => {
		const { getPlaces } = extra as { getPlaces: GetPlaces };
		const result = await getPlaces.execute(params);
		return result;
	}
);


export const onGetDetailPlaces = createAsyncThunk(
	"location/details",
	async (params: GetDetailsPlaceParams, { extra }) => {
		const { getDetailsPlace } = extra as {
			getDetailsPlace: GetDetailsPlace;
		};
		const result = await getDetailsPlace.execute(params);
		return result;
	}
);
